import AxiosControl from '../context/axios/AxiosControl'
const Axios = AxiosControl()

export const getSubscriptionProducts = () => async (dispatch) => {
    dispatch({
        type: 'SUBSCRIPTION_PRODUCT_LOADING'
    })
    try {
        const { data, status } = await Axios.get('/api/subscriptionproduct/getall/', {
            headers: { auth: sessionStorage.getItem('jwt') }
        })
        if (status === 200) {
            dispatch({
                type: 'SUBSCRIPTION_PRODUCT_GETALL_SUCCESS',
                payload: data.subscriptionProducts
            })
        } else {
            dispatch({
                type: 'SUBSCRIPTION_PRODUCT_ERROR',
                payload: 'getSubscriptionProducts'
            })
        }
    } catch (error) {
        dispatch({
            type: 'SUBSCRIPTION_PRODUCT_ERROR',
            payload: 'getSubscriptionProducts'
        })
    }
}